import { Label } from "@/components/ui/label";
import { ComboDrop } from "../ComboDrop";
import { IForm } from "@/types";
import { useFormContext } from "react-hook-form"; // To manage form state
import { cn } from "@/lib/utils";

interface Props {
    field: IForm["fields"][0];
    admin?: boolean; // If admin flag is passed
    value?: string; // Optional value prop
    className?: string;
}

export const DropdownField = ({ field, admin, value, className }: Props) => {
    const formContext = useFormContext();
    const register = admin ? () => {} : formContext.register;
    const errors = admin ? {} : formContext.formState.errors;

    // Handle onCheckedChange for non-admin users
    const handleSelectChange = (value: string) => {
        if (!admin) {
            formContext.setValue(field.id, value); // Update form value
        }
    };

    return (
        <div className={cn("flex w-full flex-col gap-1", className)}>
            <Label variant="toggle" className="!text-form-primary-text-color">
                {field.question ? (
                    field.question
                ) : (
                    <span className="text-form-primary-text-color/70">
                        Question goes here...
                    </span>
                )}
                {field.required && (
                    <span className="text-form-primary-color">*</span>
                )}
            </Label>
            <Label
                variant="subtoggle"
                className="text-form-primary-text-color/70"
            >
                {field.description}
            </Label>
            <ComboDrop
                options={field.options}
                value={value || formContext?.watch(field.id)} // Use watch to get the current value
                onSelect={handleSelectChange} // Handle the select change
                disabled={admin} // Disable for admin
            />

            {/* Validation Error Message */}
            {errors?.[field.id] && (
                <p className="text-sm text-red-500">
                    {errors[field.id]?.message?.toString()}
                </p>
            )}
        </div>
    );
};
